import React, { useContext, useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import { navigate } from 'gatsby';
import WOW from 'wowjs';
import TagManager from 'react-gtm-module';
import { YMInitializer } from 'react-yandex-metrika';
import { BRANDS, checkPartnerUID, getReferrerUrl, searchParam, GTM } from '../common';
import { brandContext } from '../store/brandContext';
import 'animate.css';
import PreLoader from '../components/templateElements/loader';
import { useInternalPaths } from '../helpers/useInternalPaths';
import { setCookie } from '../helpers';
import { readIframeData } from '../helpers/readIframeData';
import { useSetupLogs } from '../logger/useSetupLogs';
import { useSetupMetrics } from '../metrics/useSetupMetrics';

readIframeData();

const Layout = ({ path, appStore, kafkaStore, children }) => {
  const promo = require('../../static/data/promo.json');
  const brandName = useContext(brandContext);
  const favicon = require(`../icons/favicon_${brandName}.ico`);
  const pagesList = useInternalPaths();

  const [landingsLangList, setLandingsLangList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [partnerOldCode, setPartnerOldCode] = useState('');
  const [partnerUID, setPartnerUID] = useState('');
  const [partnerPromocode, setPartnerPromocode] = useState('');
  const [promoCode, setPromoCode] = useState('');
  const [referrer, setReferrer] = useState('');

  const [imprintHash, setImprintHash] = useState(() => localStorage.getItem('imprint') || '');

  useEffect(() => {
    if (imprintHash) return;

    const handleImprintReady = (event) => setImprintHash(event.detail);
    window.addEventListener('imprintReady', handleImprintReady);
    return () => window.removeEventListener('imprintReady', handleImprintReady);
  }, [imprintHash]);

  // Инициализация логов и метрики
  const yandexMetricaId = useSetupMetrics(brandName);
  useSetupLogs({ kafkaStore, referrer, imprintHash });

  const tagManagerArgs = { gtmId: GTM[brandName] };
  TagManager.initialize(tagManagerArgs);

  useEffect(() => {
    if (path === '/') return;

    const pathArray = path.split('/').filter((element) => element);
    const today = new Date();
    const [brand, alphaLang, landName] = pathArray;

    let redirectObject;
    if (Object.values(BRANDS).find((el) => el === brand)) {
      redirectObject = promo[brandName][alphaLang]?.[landName];
    }

    if (!redirectObject?.date) return;
    if (redirectObject.date && today > new Date(redirectObject.date)) {
      const redirectTo = redirectObject.redirect_to
        ? redirectObject.redirect_to
        : `/${brandName}/${alphaLang}/freebet30/`;
      navigate(redirectTo);
    }
  }, []);

  useEffect(() => {
    setPartnerUID(checkPartnerUID());
    setPartnerOldCode(searchParam('code'));
    setPartnerPromocode(searchParam('promocode'));
    setPromoCode(searchParam('promo_code'));
    setReferrer(getReferrerUrl());
    setLandingsLangList(pagesList);
  }, []);

  useEffect(() => {
    brandName && appStore.setBrandName(brandName);
  }, [brandName]);

  useEffect(() => {
    !isLoading && new WOW.WOW({ animateClass: 'animate__animated' }).init();
  }, [isLoading]);

  useEffect(() => {
    if (brandName === BRANDS.cupis) {
      setIsLoading(false);
    } else {
      appStore.initCountryDataList().finally(() => {
        setIsLoading(false);
      });
    }
  }, [brandName]);

  useEffect(() => {
    if (partnerUID) {
      setCookie('zpartner_uid', partnerUID);
    }
    if (partnerOldCode) {
      setCookie('code', partnerOldCode);
    }
  }, [partnerOldCode, partnerUID]);

  useEffect(() => {
    partnerPromocode && setCookie('partner_promocode', partnerPromocode);
  }, [partnerPromocode]);

  useEffect(() => {
    promoCode && setCookie('promo_code', promoCode);
  }, [promoCode]);

  useEffect(() => {
    landingsLangList && appStore.initLandingsLangList(landingsLangList);
  }, [landingsLangList]);

  useEffect(() => {
    document.querySelector('html').removeAttribute('style');
    document.querySelector('body').removeAttribute('style');
  });

  let pathname = window?.location?.pathname;
  if (pathname.endsWith('/cupis/ru/download-mobile/')) {
    pathname = '/app/'
  }
  let canonicalLink = `${window?.location?.origin}${pathname}`;

  if (!canonicalLink.endsWith('/')) {
    canonicalLink += '/';
  }

  return (
    <>
      {isLoading ? (
        <PreLoader />
      ) : (
        <>
          <Helmet>
            <link rel="shortcut icon" href={favicon} type="image/x-icon" />
            <link rel="canonical" href={canonicalLink} />
          </Helmet>
          <YMInitializer
            accounts={[yandexMetricaId]}
            options={{
              webvisor: true,
              clickmap: true,
              trackLinks: true,
              accurateTrackBounce: true,
            }}
            version="2"
          />
          {children}
        </>
      )}
    </>
  );
};

export default inject('appStore', 'kafkaStore')(observer(Layout));
